import { decamelizeKeys } from 'humps';
import { bettorrentPost } from '@namespace/helpers';

export const setCustomFilter = async ({ filter = [] }) =>
  bettorrentPost({
    url: '/service/pds/custom_filter/set',
    mode: 'same-origin',
    body: { filter: filter.map((item) => decamelizeKeys(item)) }
  });
